//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ElectricalRouting.js";
import "../no/Builder.js";
import "../no/Routing.js";
let d=[[[0,"DatasetName",1,0],[0,"ImportMode",1,0],[0,"ItemId",1,0],[0,"ItemRevision",1,0],[0,"ScaleFactor",1,0]],[[["nNames","names"],"GetDatasetFileNames",{},0,0],[["names"],"SetDatasetFileNames",{},1,0]],[]];
SPLM.ElectricalRouting.TeamcenterImporterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ElectricalRouting.TeamcenterImporterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;